import setCurrentPage from "src/Utils/setCurrentPage";
import UseCaseVideoPanel from "src/Components/Common/UseCaseVideoPanel";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_USE_CASE_5 = [
  {
    icon: "graphArrowUp",
    iconColor: "white",
    text: `<b>8-10%</b> improvement \nin order fill rates`,
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "customerService",
    iconColor: "white",
    text: `Respond to customer \norders in real-time with \nSLA < <b>2 seconds</b>`,
    listItemCustomStyle: { width: "288px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithRocket",
    iconColor: "white",
    text: `<b>60%</b> increase in \npartner network\n visibility`,
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_EV_DEMO_USE_CASE_5 = {
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
  title: "GEN-AI BASED CALL CENTER \nAGENT TRAINING",
  titleStyle: {
    marginTop: "-32px",
    fontSize: "100px",
    textTransform: "uppercase",
  },
  subtitle: "Use case 4",
  subtitleStyle: { color: "#92D1FF", fontSize: "24px", marginTop: "32px" },
  text: "Empower your customer service and success teams to seamlessly \ncreate, contextualize, and engage in real-time conversations across \nmultiple content and data sources, leveraging the power of Gen-AI.",
  textStyle: { marginTop: "60px", marginBottom: "40px" },
  listData: LIST_DATA_USE_CASE_5,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(403),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "EV/EV_demo_Intro_08.png",
  rightSideComponent: (
    <UseCaseVideoPanel
      infoIconClick={() => {
        setPreviousPage(416);
        setCurrentPage(419);
      }}
      imageClick={() => setCurrentPage(417)}
      title="WATCH THE DEMO VIDEO"
      image="EV/EV_demo_use_case_05.png"
    />
  ),
};

export default DATA_EV_DEMO_USE_CASE_5;
